import 'react-toastify/dist/ReactToastify.css';

import { ConfigProvider } from 'antd';
import { ToastContainer } from 'react-toastify';

// 从@ant-design/cssinjs中导入px2rem转换器和样式提供者
import {
    legacyLogicalPropertiesTransformer,
    StyleProvider,
} from '@ant-design/cssinjs';

// 定义一个样式提供者组件，它将使用状态管理和样式转换来包装其子组件
const StyleProviderCom = ({ children }: { children: React.ReactNode }) => {

    return (
        <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]} >
            <ToastContainer theme='dark' />
            <ConfigProvider
                theme={{
                    token: {
                        fontFamily: "'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Microsoft YaHei', sans-serif",
                    },
                    components: {
                        Modal: {
                            contentBg: "#3E2740", // 内容区域背景色
                            headerBg: "#3E2740", // 顶部背景色
                            titleColor: "#FFFFFF", // 标题字体颜色
                            colorIcon: "#898C88",//  控制弱操作图标的颜色，例如 allowClear 或 Alert 关闭按钮
                        },
                        Button: {
                            colorPrimary: "linear-gradient(270deg, #8A0B91 0%, #B712AF 100%)",
                            colorPrimaryHover: "linear-gradient(270deg, #8A0B91 0%, #B712AF 100%)",
                            colorPrimaryActive: "linear-gradient(270deg, #8A0B91 0%, #B712AF 100%)",
                            colorPrimaryText: "#FFFFFF",
                            defaultBg: "transparent",
                            defaultColor: "#FFFFFF",
                            defaultHoverBg: "rgba(255, 255, 255, 0.1)",
                            defaultActiveBg: "rgba(255, 255, 255, 0.2)",
                            defaultBorderColor: "#FA7CF3",
                            colorTextDisabled: "rgba(255, 255, 255, 0.25)",
                            colorBgContainerDisabled: "rgba(255, 255, 255, 0.1)",
                            borderColorDisabled: "rgba(255, 255, 255, 0.1)",

                        },
                        Input: {
                            colorBgContainer: "#3A2E3B", // 组件的容器背景色，例如：默认按钮、输入框等
                            controlHeight: 48, // Ant Design 中按钮和输入框等基础控件的高度
                            activeBorderColor: "#fff", // 激活态边框色
                            hoverBorderColor: "#fff", // 悬浮态边框色
                            colorBorder: "#fff",  // 默认使用的边框颜色
                            activeShadow: "", // 激活态阴影,
                            colorText: '#fff',
                            colorTextPlaceholder: "#AFAFAF"
                        },
                        Tabs: {
                            cardBg: "rgba(0, 0, 0, 0)",
                            cardGutter: 9,
                            horizontalItemPadding: "24px 0 12px 0",
                            itemSelectedColor: "#FA7CF3", // 标签选中态文本颜色
                            itemActiveColor: "#ADA4AE", // 标签激活态文本颜色
                            itemHoverColor: "", // 标签悬浮态文本颜色
                            itemColor: "#ADA4AE", // 标签文本颜色
                            inkBarColor: "#FA7CF3", // 指示条颜色
                            colorBorderSecondary: "transparency", // 比默认使用的边框色要浅一级，此颜色和 colorSplit 的颜色一致。使用的是实色。
                        },
                        Form: {
                            fontSize: 12, // 字体大小
                            itemMarginBottom: 20
                        },
                        InputNumber: {
                            colorBgContainer: "#3C034A", // 组件的容器背景色，例如：默认按钮、输入框等
                            controlHeight: 42, // Ant Design 中按钮和输入框等基础控件的高度
                            activeBorderColor: "#A481AA", // 激活态边框色
                            hoverBorderColor: "#A481AA", // 悬浮态边框色
                            colorBorder: "#A481AA",  // 默认使用的边框颜色
                            activeShadow: "", // 激活态阴影,
                            colorText: '#FFFFFF',
                            colorTextPlaceholder: "#AFAFAF",

                        }
                    },
                }}
            >
                {children}
            </ConfigProvider>
        </StyleProvider>
    )
}

// 导出样式提供者组件作为默认导出
export default StyleProviderCom